import * as P from 'pages';

export const routes = {
  // Anonymous:
  Login: '/login',
  OneTimeTokenLogin: '/one-time-token-login',
  Registration_Affiliate: '/registration/affiliate',
  FirstLoan: '/first-loan',
  FirstLoan_Mobile: '/first-loan-mobile',
  FirstLoan_Email: '/first-loan/email',
  FirstLoan_Confirmation: '/first-loan/confirmation',
  // Registration:
  FirstLoan_Loading: '/first-loan/check',
  FirstLoan_Welcome: '/first-loan/welcome',
  FirstLoan_PersonalData: '/first-loan/personal-data', // check atoms file before changing this route
  FirstLoan_Address: '/first-loan/address',
  FirstLoan_Income: '/first-loan/income',
  FirstLoan_PhoneVerification: '/first-loan/phone-verification',

  FirstLoan_PhoneVerification_Check: '/first-loan/phone-verification/check',
  FirstLoan_PhoneVerification_ChangePhone:
    '/first-loan/phone-verification/change-phone',
  FirstLoan_IncorrectCode: '/first-loan/incorrect-code',
  FirstLoan_Rejected: '/first-loan/rejected',

  //// Online Bank:
  FirstLoan_OnlineBank_Verify: '/first-loan/online-bank/verify',
  FirstLoan_OnlineBank_Check: '/first-loan/online-bank/check',
  FirstLoan_OnlineBank_Approved: '/first-loan/online-bank/approved',

  ////// Documents Required:
  FirstLoan_OnlineBank_DocumentsRequired:
    '/first-loan/online-bank/documents-required',

  //////// Upload:
  FirstLoan_OnlineBank_AddDocuments: '/first-loan/online-bank/add-documents',
  FirstLoan_OnlineBank_Iban: '/first-loan/online-bank/iban',
  FirstLoan_OnlineBank_Pending: '/first-loan/online-bank/pending',

  // Rejections and errors
  FirstLoan_OnlineBank_RejectedByTink:
    '/first-loan/online-bank/rejected-by-tink',
  FirstLoan_OnlineBank_Reject: '/first-loan/online-bank/reject',
  FirstLoan_OnlineBank_Error: '/first-loan/online-bank/error',

  //// Manual:
  FirstLoan_Manual: '/first-loan/manual',
  // Manual is either Upload (upload documents) or Email (user sends docs via email)
  FirstLoan_Manual_Upload: '/first-loan/manual/upload',
  FirstLoan_Manual_Upload_BankAccount: '/first-loan/manual/upload/bank-account',
  FirstLoan_Manual_Upload_Pending: '/first-loan/manual/upload/pending',

  // Affiliate (identified customer):
  Account_RepeatedLoan_Confirm: '/account/repeated-loan/confirm',
  Account_RepeatedLoan_Loading: '/account/repeated-loan/check-details',
  Account_RepeatedLoan_ApprovedApplication:
    '/account/repeated-loan/approved-application',
  Account_RepeatedLoan_RejectedApplication:
    '/account/repeated-loan/rejected-application',

  // Affiliate:
  Affiliate_ProviderName: '/affiliate/:providerName',
  Affiliate_FirstLoan_Application: '/affiliate/first-loan/application',

  // Payland
  payment_success: '/payment-success',
  payment_failed: '/payment-failed',

  best_offer: '/best-offer',
  approved: '/approved',

  firstLoan_tink_bank_na: '/first-loan/tink/bank-na',
  firstLoan_tink_bank_issue: '/first-loan/tink/bank-issue',
  firstLoan_tink_later: '/first-loan/tink/later',
};

// Appmap used to render the screens inside Router
export const AppMap = {
  [routes.OneTimeTokenLogin]: {
    nonDynamicComponent: P.OneTimeTokenLogin,
  },
  [routes.Registration_Affiliate]: {
    nonDynamicComponent: P.OneTimeTokenLogin,
  },
  [routes.FirstLoan]: {
    nonDynamicComponent: P.Introduction,
    authenticated: false, // Setting false explicitly because it's a fallback route for non-authentitated users and it should be always accessible by those
  },
  [routes.FirstLoan_Mobile]: {
    nonDynamicComponent: P.Introduction,
    authenticated: false,
  },
  [routes.FirstLoan_Email]: {
    nonDynamicComponent: P.Identification,
    authenticated: false,
  },
  [routes.FirstLoan_Confirmation]: {
    nonDynamicComponent: P.Confirmation,
  },
  [routes.FirstLoan_Welcome]: {
    nonDynamicComponent: P.Welcome,
    authenticated: true,
  },
  //// client registered and authenticated
  [routes.FirstLoan_PersonalData]: {
    nonDynamicComponent: P.PersonalData,
    authenticated: true,
  },
  [routes.FirstLoan_Address]: {
    nonDynamicComponent: P.AddressDetails,
    authenticated: true,
  },
  [routes.FirstLoan_Income]: {
    nonDynamicComponent: P.IncomeDetails,
    authenticated: true,
  },
  [routes.FirstLoan_PhoneVerification]: {
    nonDynamicComponent: P.PhoneVerification,
    authenticated: true,
  },
  [routes.FirstLoan_PhoneVerification_Check]: {
    nonDynamicComponent: P.ResolutionResolverPhoneVerification,
    authenticated: true,
  },
  [routes.FirstLoan_PhoneVerification_ChangePhone]: {
    nonDynamicComponent: P.PhoneVerificationChangePhone,
    authenticated: true,
  },
  [routes.FirstLoan_IncorrectCode]: {
    nonDynamicComponent: P.IncorrectCode,
    authenticated: true,
  },
  [routes.FirstLoan_OnlineBank_Error]: {
    nonDynamicComponent: P.OnlineBankError,
    authenticated: true,
  },
  //// Online Bank:
  [routes.FirstLoan_OnlineBank_Verify]: {
    nonDynamicComponent: P.OnlineBankVerification,
    authenticated: true,
  },
  [routes.FirstLoan_OnlineBank_Check]: {
    nonDynamicComponent: P.OnlineBankWaiting,
    authenticated: true,
  },
  [routes.FirstLoan_OnlineBank_Approved]: {
    nonDynamicComponent: P.Approved,
    authenticated: true,
  },
  ////// Documents Required:
  [routes.FirstLoan_OnlineBank_DocumentsRequired]: {
    nonDynamicComponent: P.FirstLoanDocumentsRequired,
    authenticated: true,
  },
  //////// Upload:
  [routes.FirstLoan_OnlineBank_AddDocuments]: {
    nonDynamicComponent: P.RegistrationUploadDoc,
    authenticated: true,
  },
  [routes.FirstLoan_OnlineBank_Iban]: {
    nonDynamicComponent: P.BankAccount,
    authenticated: true,
  },
  [routes.FirstLoan_OnlineBank_Pending]: {
    nonDynamicComponent: P.RegistrationSuccess,
    authenticated: true,
  },
  ////////
  [routes.FirstLoan_OnlineBank_RejectedByTink]: {
    nonDynamicComponent: P.RegistrationRejected,
    authenticated: true,
  },
  [routes.FirstLoan_OnlineBank_Reject]: {
    nonDynamicComponent: P.RegistrationRejected,
    authenticated: true,
  },
  // Manual:
  [routes.FirstLoan_Manual_Upload]: {
    nonDynamicComponent: P.RegistrationUploadDoc,
    authenticated: true,
  },
  [routes.FirstLoan_Manual_Upload_BankAccount]: {
    nonDynamicComponent: P.BankAccount,
    authenticated: true,
  },
  [routes.FirstLoan_Manual_Upload_Pending]: {
    nonDynamicComponent: P.RegistrationSuccess,
    authenticated: true,
  },
  // Repeated Loan
  [routes.Account_RepeatedLoan_Confirm]: {
    nonDynamicComponent: P.RepeatedLoanConfirm,
    authenticated: true,
  },
  [routes.FirstLoan_Loading]: {
    nonDynamicComponent: P.RegistrationLoading,
    authenticated: true,
  },
  [routes.Account_RepeatedLoan_Loading]: {
    nonDynamicComponent: P.RegistrationLoading,
    // component: () => import('./pages/RegistrationLoading/RegistrationLoading'),
    authenticated: true,
  },
  // Affiliate
  [routes.Affiliate_ProviderName]: {
    nonDynamicComponent: P.AffiliateProvider,
  },
  [routes.Affiliate_FirstLoan_Application]: {
    nonDynamicComponent: P.AffiliateFirstLoan,
    authenticated: true,
  },
  [routes.FirstLoan_Rejected]: {
    nonDynamicComponent: P.RegistrationRejected,
    authenticated: true,
  },
  [routes.Account_RepeatedLoan_ApprovedApplication]: {
    nonDynamicComponent: P.RepeatedLoanSuccess,
    authenticated: true,
  },
  [routes.Account_RepeatedLoan_RejectedApplication]: {
    nonDynamicComponent: P.RepeatedLoanRejected,
    authenticated: true,
  },
  [routes.payment_success]: {
    nonDynamicComponent: P.PaymentSuccess,
    authenticated: true,
  },
  [routes.payment_failed]: {
    nonDynamicComponent: P.PaymentFailed,
    authenticated: true,
  },
  [routes.best_offer]: {
    nonDynamicComponent: P.BestOffer,
    authenticated: true,
  },
  [routes.approved]: {
    nonDynamicComponent: P.Approved,
    authenticated: true,
  },
  '*': {
    nonDynamicComponent: P.NotFound,
  },
  [routes.firstLoan_tink_bank_na]: {
    nonDynamicComponent: P.TinkBankNA,
    authenticated: true,
  },
  [routes.firstLoan_tink_bank_issue]: {
    nonDynamicComponent: P.TinkBankIssue,
    authenticated: true,
  },
  [routes.firstLoan_tink_later]: {
    nonDynamicComponent: P.TinkLater,
    authenticated: true,
  },
};
